import { render, staticRenderFns } from "./Hangseng.vue?vue&type=template&id=59edc446&"
import script from "./Hangseng.vue?vue&type=script&lang=js&"
export * from "./Hangseng.vue?vue&type=script&lang=js&"
import style0 from "./Hangseng.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports